
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    // Check if we're on the homepage
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with hash
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="bg-black text-white pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Million Dollar Contractors</h3>
            <p className="text-gray-400 mb-6">
              Transforming home service contractors into million-dollar businesses through cutting-edge digital marketing.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-red-500 text-xl flex-shrink-0"></i>
                <a href="tel:2153963311" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  (215) 396-3311
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-red-500 text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-400">
                  33 SE 4th St #100<br />
                  Boca Raton, FL 33432
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('industries')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  Industries
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="/services/web-design" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Web Design
                </a>
              </li>
              <li>
                <a href="/services/ai-integration" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  AI Integration
                </a>
              </li>
              <li>
                <a href="/services/seo" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  SEO Optimization
                </a>
              </li>
              <li>
                <a href="/services/social-media" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Social Media Marketing
                </a>
              </li>
              <li>
                <a href="/services/google-ads" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Google Ads &amp; LSA
                </a>
              </li>
              <li>
                <a href="/services/reputation-management" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Reputation Management
                </a>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-lg font-bold mb-4">Industries We Serve</h4>
            <ul className="space-y-3">
              <li>
                <a href="/industries/electrical" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Electrical
                </a>
              </li>
              <li>
                <a href="/industries/hvac" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  HVAC
                </a>
              </li>
              <li>
                <a href="/industries/plumbing" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Plumbing
                </a>
              </li>
              <li>
                <a href="/industries/roofing" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Roofing
                </a>
              </li>
              <li>
                <a href="/industries/landscaping" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Landscaping
                </a>
              </li>
              <li>
                <a href="/industries/pest-control" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
                  Pest Control
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col md:flex-row items-center gap-4 text-sm">
            <p className="text-gray-400 text-center md:text-left">
              © 2026 Million Dollar Contractors. All rights reserved.
            </p>
            <a 
              href="https://www.mediacomponents.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Website by: Media Components
            </a>
          </div>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}